import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
// import DeleteIcon from '@material-ui/icons/Delete';

const facebook_logo = require("../../images/facebook.png");
const twitter_logo = require("../../images/twitter.png");
const linkedin_logo = require("../../images/linkedin2.png");

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      '& > *': {
        margin: theme.spacing(0),
      },
    },
    buttonMain:{
        border:'1 solid #4e4e4e',
        borderRadius:'100%',
        outline:'none',
        '&.MuiIconButton-root':{
            padding: '2px 7px 7px 7px',
            outline:'none'
        }
    },
    buttonIconImage:{
        width:20,
        borderRadius:'100%',
        border:'1px solid black',
        padding:3
    },
    link:{
      width:22,
      '&.hover':{
        backgroundColor:'transparent !important' 
      }
    }
  }),
);

export default function IconButtonsGroup() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <IconButton aria-label="twitter" className={classes.buttonMain} >
        <a href="https://twitter.com/IoMeetrix" target="blank">
        <img src={twitter_logo} alt="twitter" className={classes.buttonIconImage}/>
        </a>
      </IconButton>

      <IconButton aria-label="facebook" className={classes.buttonMain}>
        <a href="https://www.facebook.com/meetrix" target="blank">
          <img src={facebook_logo} alt="facebook" className={classes.buttonIconImage}/>
        </a>
      </IconButton>

      <IconButton aria-label="linkedin" className={classes.buttonMain}>
        <a href="https://www.linkedin.com/company/meetrixio" target="blank">
          <img src={linkedin_logo} alt="linkedin" style={{width:24}}/>
        </a>
      </IconButton>
    </div>
  );
}
